import { useApi } from "#hooks/useApi"
import { vacationHolidaysGet } from "#vacation/services/api"
import dayjs from "dayjs"
import { useMemo } from "react"

export const UseHolidays = (colaborador, date_start, date_end) => {
	const params = useMemo(() => ({ colaborador }), [colaborador])
	const { data } = useApi(vacationHolidaysGet, { autoFetch: true, params })

	const holidays = useMemo(() => {
		let holidays = []
		if (data?.data) holidays = data?.data
		if (!date_start?.isValid() || !date_end?.isValid()) return []

		const year_start = date_start.year()
		const year_end = date_end.year()
		let holidays_list = []
		if (!holidays?.date)
			for (let year = year_start; year <= year_end; year++) {
				holidays.forEach((holiday) => {
					holiday["date"] = dayjs(
						`${holiday.month}-${holiday.day}-${year}`,
						"M-D-YYYY"
					).$d

					holidays_list.push({ ...holiday })
				})
			}

		return holidays_list.filter(
			(holiday) =>
				holiday.date >= date_start.$d &&
				date_end.$d >= holiday.date &&
				dayjs(holiday.date).day() !== 0
		)
	}, [data?.data, date_end, date_start])
	const sundays = useMemo(() => {
		if (!date_start?.isValid() || !date_end?.isValid()) return []

		let dates = []
		let date = date_start
		while (date.$d <= date_end.$d) {
			if (date.day() === 0) {
				dates.push({ date, name: "Domingo" })
				date = date.add(7, "day")
			} else date = date.add(1, "day")
		}
		return dates
	}, [date_end, date_start])

	const descanso = useMemo(() => {
		return [...holidays, ...sundays].sort((date_a, date_b) => {
			date_a = date_a?.date || date_a
			date_b = date_b?.date || date_b

			return date_a - date_b
		})
	}, [holidays, sundays])
	return descanso
}
